import { useState } from "react";
import { ChevronDown } from "@marbletech/core";

import { useTranslation } from "@flare/i18n";

import { Link } from "@/components/Link";
import { Heading } from "@/components/v2/Heading/Heading";
import { Text } from "@/components/v2/Text/Text";
import { i18n } from "@/services/locale/i18n";

export const footerLinks = [
  {
    text: i18n.t("FUNNEL_FOOTER_LINK_MANAGING_ATTORNEYS"),
    pathname: "/our-attorneys",
  },
  {
    text: i18n.t("FUNNEL_FOOTER_LINK_PRIVACY"),
    pathname: "/privacy",
  },
  {
    text: i18n.t("FUNNEL_FOOTER_LINK_TERMS"),
    pathname: "/terms-of-use",
  },
  {
    text: i18n.t("FUNNEL_FOOTER_LINK_DO_NOT_SELL_INFO"),
    pathname: "/do-not-sell-my-info",
  },
  {
    text: i18n.t("FUNNEL_FOOTER_LINK_DISABILITY_FORM"),
    pathname: "/disability-contact-form",
  },
];

export function Footer() {
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const { t } = useTranslation();

  const footerArrowsClickHandler = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    setShowDisclaimer((disclaimerVisibility) => !disclaimerVisibility);
  };

  return (
    <footer className="bg-green-20">
      <div className="m-auto max-w-[1440px]">
        <div className="px-5 pb-10 pt-16">
          <div className="flex flex-row items-center justify-between md:justify-normal">
            <Heading variant="h5">
              {t("FUNNEL_FOOTER_DISCLAIMER_TITLE")}
            </Heading>
            <button
              type="button"
              className={`cursor-pointer transition-transform duration-200 ${showDisclaimer ? "rotate-180" : "rotate-0"}`}
              onClick={footerArrowsClickHandler}
            >
              <ChevronDown />
            </button>
          </div>
          {showDisclaimer && (
            <Text variant="text-5" className="pt-6">
              {t("FUNNEL_FOOTER_DISCLAIMER_TEXT")}
            </Text>
          )}
        </div>
        <div className="h-px bg-green-50" />
        <div className="px-5 pb-36 pt-8 md:py-8">
          <div className="flex flex-col gap-8 md:flex-row">
            {footerLinks.map(({ pathname, text }) => (
              <Link key={pathname} pathname={pathname}>
                <Text variant="text-5">{text}</Text>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
